import { IOrderData } from '@app/@shared/Models/order.model';
import { IBulkAcceptanceData, } from '@app/@shared/Models/bulk-acceptance.model';
import { ICategoriesData } from '@app/@shared/Models/all-categories.model';


export interface IAppState {
    Order: IOrderData,
    BulkOrderAcceptance: IBulkAcceptanceData,
    AllCategoriesData: ICategoriesData
}

export interface IError {
    statusCode?: number;
    errorMessage?: string;
}

export const initializeOrderState = (): IOrderData => {
    return null;
};

export const initializeBulkAcceptanceState = (): IBulkAcceptanceData => {
    return null;
}

export const initializeAllCategoriesState = (): ICategoriesData => {
    return null;
}